import { useEffect, useState } from "react";
import { db } from "../Firebase";
import {
  collection,
  query,
  where,
  getDocs,
  doc,
  getDoc
} from "firebase/firestore";
import "../styles/ReviewPopup.css";

const ReviewPopup = ({ courseId, onClose }) => {
  const [reviews, setReviews] = useState([]);
  const [stats, setStats] = useState({ 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!courseId) return;

    const fetchReviews = async () => {
      setLoading(true);

      const snap = await getDocs(
        query(
          collection(db, "reviews"),
          where("courseId", "==", courseId)
        )
      );

      const list = [];
      const ratingCount = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };

      for (const d of snap.docs) {
        const data = d.data();

        const rating = Number(data.rating); // ✅ FIX

        if (rating >= 1 && rating <= 5) {
          ratingCount[rating]++;
        }

        let userName = "Anonymous";
        try {
          const userSnap = await getDoc(doc(db, "users", data.userId));
          if (userSnap.exists()) {
            userName =
              userSnap.data().name ||
              userSnap.data().username ||
              "Student";
          }
        } catch {}

        list.push({
          rating,
          review: data.review,
          userName,
          createdAt: data.createdAt
        });
      }


      setReviews(list);
      setStats(ratingCount);
      setLoading(false);
    };

    fetchReviews();
  }, [courseId]);

  return (
    <div className="review-modal-overlay" onClick={onClose}>
      <div className="review-modal" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>✕</button>

        <h2>Student Reviews</h2>

        {loading && <p>Loading reviews…</p>}

        {/*  Rating Summary */}
        <div className="rating-summary">
          {[5, 4, 3, 2, 1].map((star) => (
            <div key={star} className="rating-row">
              <span>{star} ★</span>
              <div className="bar">
                <div
                  className="fill"
                  style={{
                    width: `${
                      reviews.length
                        ? (stats[star] / reviews.length) * 100
                        : 0
                    }%`
                  }}
                />
              </div>
              <span>{stats[star]}</span>
            </div>
          ))}
        </div>

        {/* 📝 Reviews List */}
        <div className="review-list">
          {reviews.length === 0 && !loading && (
            <p>No reviews yet.</p>
          )}

          {reviews.map((r, i) => (
            <div key={i} className="review-item">
              <div className="review-header">
                <strong>{r.userName}</strong>
                <span>{"★".repeat(r.rating)}</span>
              </div>
              <p>{r.review || "No comment"}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ReviewPopup;
